import { createContext, type ReactNode, useContext, useMemo } from 'react';

interface ViewContextType {
  loopId: number;
  viewId: number;
  isPublishedMode: boolean;
}

export const ViewContext = createContext<ViewContextType | undefined>(undefined);

interface ViewProviderProps {
  loopId?: number;
  viewId: number;
  isPublishedMode?: boolean;
  children: ReactNode;
}

export function ViewContextProvider({
  viewId,
  loopId,
  isPublishedMode = false,
  children,
}: ViewProviderProps) {
  const value = useMemo(
    () => ({ viewId, loopId: loopId || 0, isPublishedMode }),
    [viewId, loopId, isPublishedMode],
  );

  return <ViewContext.Provider value={value}>{children}</ViewContext.Provider>;
}

export function useViewContext() {
  const context = useContext(ViewContext);
  if (context === undefined) {
    throw new Error('useViewContext must be used within a ViewContextProvider');
  }
  return context;
}
